import { useEffect, useState } from 'react';
import SidebarFilter from './SidebarFilter';
import useTopics from '../../hooks/useTopics';
import { useSearchParams } from 'react-router';
import TopicList from '../../components/ui/TopicList';
import { useForm } from 'react-hook-form';

const DiscoverPage = () => {
  let [searchParams, setSearchParams] = useSearchParams();
  const [searchInput, setSearchInput] = useState(searchParams.get('search') || '');

  let {register, control, getValues, watch, formState: {errors}} = useForm({defaultValues: {
    faculty: null,
    department: null,
    level: null
  }})

  const { topics, loading, error, fetchTopics } = useTopics({search_text: searchParams.get('search')});


  useEffect(() => {
    const timeout = setTimeout(() => {
      setSearchParams({ search: searchInput });
    }, 500);
  
    return () => clearTimeout(timeout);
  }, [searchInput]);

  useEffect(() => {
    let searchInput = searchParams.get('search')
    searchTopic()
  }, [searchParams.get('search')]);

  const searchTopic = ()=> {
    fetchTopics({
      search_text: searchInput,
      department_id: getValues('department'),
      faculty_id: getValues('faculty'),
      level: getValues('level'),
      with_quiz: true,
    })
  }

  return (
    <div className="max-w-[1500px] mx-auto p-4 mt-16">
      <div className="flex gap-12">
        {/* Sidebar */}
        <div className="w-5/12 max-w-[340px] hidden md:block">
          <SidebarFilter
            register={register}
            errors={errors}
            watch={watch}
            control={control}
            onApplyFilters={searchTopic}
          />
        </div>

        {/* Main Content */}
        <div className="grow">
          <h1 className="text-4xl font-medium font-inter text-gray-800 mb-6">Discover Topics</h1>
          <div className="flex items-center gap-4 mb-6">
            <input
              type="text"
              value={searchInput}
              placeholder="Search for topics..."
              onChange={(e) => setSearchInput(e.target.value)}
              className="input input-bordered w-full"
            />
          </div>

          {loading ? (
            <div className="text-center py-4">Loading...</div>
          ) : error ? (
            <div className="text-center py-4 text-red-500">Error loading topics</div>
          ) : topics.length === 0 ? (
            <div className="text-center py-4 text-gray-500">No topics found</div>
          ) : (
            <>
              <h2 className="text-2xl font-medium text-gray-700 mb-4">Start your learning here ☺️</h2>
              <TopicList topics={topics} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default DiscoverPage;
